import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'avmFormNullableValue',
    standalone: true,
})
export class AvmFormNullableValue implements PipeTransform {
    /**
     * Formate une valeur d'un formulaire pour afficher un tiret lorsque la valeur est vide ou nulle et que le formulaire est en read-only.
     * @param value : Valeur à formatter.
     * @param readonly : Mode du formulaire.
     * @param displayFormat : Format à appliquer.
     */
    transform(value: string, readonly: boolean, displayFormat: string = null): string {
        let formatedValue = value;

        if (displayFormat) {
            switch (displayFormat) {
                case 'XXXXXXXXXX':
                    formatedValue = this.getFormatedPhoneNumber(value, '');
                    break;
                case 'XX XX XX XX XX':
                    formatedValue = this.getFormatedPhoneNumber(value, ' ');
                    break;
                case 'XX.XX.XX.XX.XX':
                    formatedValue = this.getFormatedPhoneNumber(value, '.');
                    break;
                case 'XX-XX-XX-XX-XX':
                    formatedValue = this.getFormatedPhoneNumber(value, '-');
                    break;
                default:
                    formatedValue = value;
            }
        }

        if (readonly) {
            if (formatedValue && formatedValue.length > 0) {
                return formatedValue;
            } else {
                return '-';
            }
        } else {
            return formatedValue;
        }
    }

    private getFormatedPhoneNumber(phoneNumber: string, separator: string): string {
        if (phoneNumber) {
            let parts = this.splitPhoneNumber(phoneNumber);
            return parts.join(separator);
        } else {
            return null;
        }
    }

    private splitPhoneNumber(phoneNumber: string): string[] {
        let parts: string[] = [];
        let reversePhoneNumber = phoneNumber.split('').reverse().join('');
        parts.push(reversePhoneNumber.substring(0, 2).split('').reverse().join(''));
        reversePhoneNumber = reversePhoneNumber.substring(2);
        parts.push(reversePhoneNumber.substring(0, 2).split('').reverse().join(''));
        reversePhoneNumber = reversePhoneNumber.substring(2);
        parts.push(reversePhoneNumber.substring(0, 2).split('').reverse().join(''));
        reversePhoneNumber = reversePhoneNumber.substring(2);
        parts.push(reversePhoneNumber.substring(0, 2).split('').reverse().join(''));
        reversePhoneNumber = reversePhoneNumber.substring(2);
        if (reversePhoneNumber.length === 2) {
            parts.push(reversePhoneNumber.substring(0, 2).split('').reverse().join(''));
            reversePhoneNumber = reversePhoneNumber.substring(2);
        } else {
            let lastPart = reversePhoneNumber.substring(0, 1).split('').reverse().join('');
            reversePhoneNumber = reversePhoneNumber.substring(1);
            let indicatif = `(${reversePhoneNumber.split('').reverse().join('')})`;
            parts.push(`${indicatif} ${lastPart}`);
        }

        return parts.reverse();
    }
}
